/**
 * Трансформация объекта в FormData
 */
export function toFormData(obj: Record<string, any>): FormData {
    const formData = new FormData();

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];

            if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    formData.append(`${key}[]`, item);
                });
            } else if (value instanceof File) {
                formData.append(key, value);
            } else {
                formData.append(key, String(value));
            }
        }
    }

    return formData;
}

/**
 * Убирает из объекта пустые строки, null и undefined
 */
export function omitEmptyFields<T extends Record<string, unknown>>(obj: T): Partial<T> {
    return Object.fromEntries(
        Object.entries(obj).filter(([, value]) => value !== '' && value !== null && value !== undefined),
    ) as Partial<T>;
}
